import { useState } from "react";

export default function TermsAndConditionsModal() {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  // Expose the openModal function globally so footer can access it
  if (typeof window !== "undefined") {
    window.openTermsModal = openModal;
  }

  return (
    <>
      {isOpen && (
        <div className="terms-modal-overlay" onClick={closeModal}>
          <div
            className="terms-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="terms-modal-header">
              <h2>Terms and Conditions</h2>
              <button className="terms-modal-close" onClick={closeModal}>
                ×
              </button>
            </div>

            <div className="terms-modal-body">
              <div className="terms-content">
                <div className="terms-title">
                  <img
                    src="/assets/images/Logo.png"
                    style={{ display: "block", margin: "0 auto", width: "16%" }}
                    alt="Little Logo"
                  />
                </div>
                <br />
                <section>
                  <h3>1. Acceptance of Terms</h3>
                  <p>
                    By continuing usage of the Application, You are consenting
                    to be bound by these T&Cs for use and access of the
                    Application.
                  </p>
                  <p>
                    PLEASE ENSURE THAT YOU READ AND UNDERSTAND ALL THESE T&Cs
                    BEFORE YOU USE ANY OF THE SERVICES OFFERED ON THE
                    APPLICATION, BECAUSE YOU SHALL BE BOUND BY ALL THE TERMS AND
                    CONDITIONS CONTAINED HEREIN.
                  </p>
                </section>

                <section>
                  <h3>2. License Grant</h3>
                  <p>
                    Subject to your compliance with these Terms, LITTLE grants
                    you a limited, non-exclusive, non-sublicensable, revocable,
                    non-transferrable license to:
                  </p>
                  <ul>
                    <li>
                      Access and use the Applications on your personal device
                      solely in connection with your use of the Services
                    </li>
                    <li>
                      Access and use any content, information and related
                      materials that may be made available through the Services
                    </li>
                  </ul>
                  <p>
                    Any rights not expressly granted herein are reserved by
                    LITTLE and LITTLE's licensors.
                  </p>
                </section>

                <section>
                  <h3>3. Service Description</h3>
                  <p>
                    The Services constitute a technology platform that enables
                    users of Little's mobile applications or website to arrange
                    and schedule transportation services with independent third
                    party service providers.
                  </p>
                  <p>
                    <strong>
                      YOU ACKNOWLEDGE THAT LITTLE DOES NOT PROVIDE
                      TRANSPORTATION OR LOGISTICS SERVICES OR FUNCTION AS A
                      TRANSPORTATION CARRIER OR TAXI COMPANY
                    </strong>{" "}
                    and that all such transportation or logistics services are
                    provided by independent third party contractors and service
                    providers who are not employed by LITTLE.
                  </p>
                </section>

                <section>
                  <h3>4. Definitions</h3>
                  <div className="definitions-grid">
                    <div className="definition-item">
                      <strong>Account</strong>
                      <p>
                        The account created by the Customer on the Application
                      </p>
                    </div>
                    <div className="definition-item">
                      <strong>Application</strong>
                      <p>
                        The mobile application "LITTLE" as may be updated by
                        Little Ltd from time to time
                      </p>
                    </div>
                    <div className="definition-item">
                      <strong>Customer/You</strong>
                      <p>
                        A person who has agreed to our terms and conditions and
                        has an Account on the Application
                      </p>
                    </div>
                    <div className="definition-item">
                      <strong>LITTLE/COMPANY</strong>
                      <p>
                        Little Limited, registered under the Companies Act of
                        Kenya
                      </p>
                    </div>
                    <div className="definition-item">
                      <strong>Ride</strong>
                      <p>
                        The travel in the Vehicle by the Customer from the Pick
                        Up point to the Drop point
                      </p>
                    </div>
                    <div className="definition-item">
                      <strong>Service Provider</strong>
                      <p>
                        Third party individuals offering vehicle services with
                        valid Public Service Vehicle licenses
                      </p>
                    </div>
                  </div>
                </section>

                <section>
                  <h3>5. Eligibility</h3>
                  <p>
                    You will be "Eligible" to use the Services only when You
                    fulfil all of the following conditions:
                  </p>
                  <ul>
                    <li>
                      You have attained at least 18 (eighteen) years of age
                    </li>
                    <li>
                      You are competent to enter into a contract under the
                      Applicable Laws
                    </li>
                    <li>You have a valid registered mobile number</li>
                    <li>
                      You agree to comply with our terms and conditions of use
                    </li>
                  </ul>
                </section>

                <section>
                  <h3>6. Registration and Account</h3>
                  <p>
                    You understand and acknowledge that You can register on the
                    Application only after complying with the eligibility
                    requirements and through a valid Email ID.
                  </p>
                  <p>
                    We reserve the right to suspend or terminate Your Account
                    with immediate effect if:
                  </p>
                  <ul>
                    <li>
                      We have reason to believe that the Registration Data is
                      incorrect or false
                    </li>
                    <li>The security of Your Account has been compromised</li>
                    <li>We receive any complaint from the Service Provider</li>
                  </ul>
                </section>

                <section>
                  <h3>7. User Responsibilities</h3>
                  <p>By using the mobile Application, you agree that:</p>
                  <ul>
                    <li>
                      You will download the Application for your sole, personal
                      use
                    </li>
                    <li>You will not authorize others to use your account</li>
                    <li>
                      You will not use the Application for unlawful purposes
                    </li>
                    <li>
                      You will not cause nuisance, annoyance or inconvenience
                    </li>
                    <li>
                      You will keep secure and confidential your account
                      password
                    </li>
                  </ul>
                </section>

                <section>
                  <h3>8. Booking Process</h3>
                  <p>
                    You may download the Application on Your device for availing
                    the Service. For making a booking:
                  </p>
                  <ol>
                    <li>Enter the destination on the booking screen</li>
                    <li>The pick-up address will be fixed to Your location</li>
                    <li>
                      Review the ETT (estimated travel time) and ride fare
                    </li>
                    <li>Hit the 'I Confirm' icon to proceed</li>
                  </ol>
                </section>

                <section>
                  <h3>9. Payment Methods</h3>
                  <div className="payment-methods">
                    <div className="payment-method">
                      <h4>Cash Payment</h4>
                      <p>
                        Cash payment shall be made at the time of boarding the
                        taxi
                      </p>
                    </div>
                    <div className="payment-method">
                      <h4>MPESA Payment</h4>
                      <p>
                        Mobile payment for trips shall be made through MPESA or
                        ELMA at the time You board the Vehicle
                      </p>
                    </div>
                  </div>
                </section>

                <section>
                  <h3>10. Cancellation Policy</h3>
                  <p>
                    You may cancel the booking as early as possible prior to the
                    boarding of the Vehicle and commencement of the Ride,
                    without any cancellation charges.
                  </p>
                </section>

                <section>
                  <h3>11. Waiting Policy</h3>
                  <p>
                    The SERVICE PROVIDER shall wait only for 2 (Two) minutes for
                    the Customer at the pick location. If the customer does not
                    board within 2 minutes, the SERVICE PROVIDER/LITTLE may
                    cancel the trip.
                  </p>
                </section>

                <section>
                  <h3>12. Disclaimer of Warranties</h3>
                  <p>
                    THE SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE." LITTLE
                    DISCLAIMS ALL REPRESENTATIONS AND WARRANTIES, EXPRESS,
                    IMPLIED OR STATUTORY, NOT EXPRESSLY SET OUT IN THESE TERMS.
                  </p>
                </section>

                <section>
                  <h3>13. Limitation of Liability</h3>
                  <p>
                    IN ANY EVENT LITTLE'S TOTAL LIABILITY TO YOU IN CONNECTION
                    WITH THE SERVICES FOR ALL DAMAGES, LOSSES AND CAUSES OF
                    ACTION SHALL NOT EXCEED KENYA SHILLINGS FIVE THOUSAND (Kes
                    5000).
                  </p>
                </section>

                <section>
                  <h3>14. Governing Law and Dispute Resolution</h3>
                  <p>
                    This T&Cs shall be governed by and construed in accordance
                    with the laws of Kenya. Any disputes shall be settled
                    through mutual consultation and, if unresolved, referred to
                    arbitration in accordance with the provisions of the
                    Arbitration Act of Kenya.
                  </p>
                </section>

                <section>
                  <h3>15. Contact Information</h3>
                  <p>
                    For any complaints or grievances, please contact Our
                    customer care at:
                  </p>
                  <p>
                    <strong>Email:</strong> info.india@little.global
                  </p>
                  <p>
                    <strong>Address:</strong> 524-255, 5th Floor, Indraprastha
                    Bussiness Park, Ahmedabad, Gujarat, India
                  </p>
                </section>

                <div className="terms-footer">
                  <p>
                    By using our services, you acknowledge that you have read,
                    understood, and agree to be bound by these Terms and
                    Conditions.
                  </p>
                </div>
              </div>
            </div>

            {/* <div className="terms-modal-footer">
              <button className="terms-agree-button" onClick={closeModal}>
                I Understand
              </button>
            </div> */}
          </div>
        </div>
      )}

      <style jsx>{`
        .terms-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          padding: 20px;
        }

        .terms-modal-content {
          background-color: white;
          border-radius: 8px;
          max-width: 800px;
          width: 100%;
          max-height: 90vh;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }

        .terms-modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px;
          border-bottom: 1px solid #e5e5e5;
          background-color: #f8f9fa;
        }

        .terms-modal-header h2 {
          margin: 0;
          color: #333;
          font-size: 1.5rem;
        }

        .terms-modal-close {
          background: none;
          border: none;
          font-size: 32px;
          cursor: pointer;
          color: #666;
          padding: 0;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .terms-modal-close:hover {
          color: #333;
        }

        .terms-modal-body {
          flex: 1;
          overflow-y: auto;
          padding: 20px;
        }

        .terms-content {
          line-height: 1.6;
          color: #333;
        }

        .terms-content section {
          margin-bottom: 24px;
        }

        .terms-content h3 {
          color: #2c5aa0;
          margin-bottom: 12px;
          font-size: 1.2rem;
        }

        .terms-content h4 {
          color: #2c5aa0;
          margin-bottom: 8px;
          font-size: 1.1rem;
        }

        .terms-content p {
          margin-bottom: 12px;
        }

        .terms-content ul,
        .terms-content ol {
          margin-bottom: 12px;
          padding-left: 20px;
        }

        .terms-content li {
          margin-bottom: 8px;
        }

        .definitions-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 16px;
          margin-top: 16px;
        }

        .definition-item {
          padding: 12px;
          background-color: #f8f9fa;
          border-radius: 4px;
          border-left: 3px solid #2c5aa0;
        }

        .definition-item strong {
          display: block;
          margin-bottom: 4px;
          color: #2c5aa0;
        }

        .payment-methods {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 16px;
          margin-top: 16px;
        }

        .payment-method {
          padding: 16px;
          background-color: #f8f9fa;
          border-radius: 4px;
          border: 1px solid #e5e5e5;
        }

        .terms-footer {
          margin-top: 24px;
          padding-top: 16px;
          border-top: 1px solid #e5e5e5;
          font-style: italic;
        }

        .terms-modal-footer {
          padding: 20px;
          border-top: 1px solid #e5e5e5;
          display: flex;
          justify-content: flex-end;
          background-color: #f8f9fa;
        }

        .terms-agree-button {
          background-color: #2c5aa0;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 4px;
          cursor: pointer;
          font-size: 1rem;
        }

        .terms-agree-button:hover {
          background-color: #1e3d6f;
        }

        @media (max-width: 768px) {
          .terms-modal-content {
            max-height: 95vh;
          }

          .terms-modal-header h2 {
            font-size: 1.3rem;
          }

          .definitions-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </>
  );
}
